import { z } from 'zod';
import { IsoTimestamp } from './common';
import { MaskableFieldKeySchema } from './admin-masking';

export const AdminAction = z.enum([
  'REVEAL_PII',
  'EDIT_PREFS',
  'EDIT_ANSWER_BANK',
  'REPLACE_RESUME',
  'CHANGE_TIER',
  'SUSPEND',
  'UNSUSPEND',
  'DELETE_USER',
  'REPLAY_RUN',
  'CANCEL_RUN',
  'REVOKE_DEVICE',
  'ISSUE_PAIRING_CODE',
  'SET_FEATURE_FLAG',
  'CLEAR_FEATURE_FLAG',
  'ISSUE_CLAUDE_TOKEN',
  'REVOKE_CLAUDE_TOKEN',
  'START_TRIAGE',
  'STOP_TRIAGE',
  'ENABLE_AUTO_MERGE',
  'TOGGLE_AUTO_RUN_MODE',
  'ADD_NOTE',
  'CLASSIFY_FINDING',
  'RESOLVE_FINDING',
  'DISMISS_FINDING',
  'OPEN_PR',
  'MERGE_PR',
  'CLOSE_PR_AUTO_MERGE_BLOCKED',
  'REMOVE_WAITLIST_ENTRY',
]);
export type AdminAction = z.infer<typeof AdminAction>;

export const AdminAudit = z.object({
  actionId: z.string().uuid(),
  actorEmail: z.string().email(),
  actorUserId: z.string(),
  action: AdminAction,
  targetUserId: z.string().optional(),
  targetEntity: z.string().optional(),
  oldValue: z.unknown().optional(),
  newValue: z.unknown().optional(),
  reason: z.string(),
  ip: z.string(),
  userAgent: z.string(),
  triageSessionId: z.string().optional(),
  revealedFields: z.array(MaskableFieldKeySchema).optional(),
  createdAt: IsoTimestamp,
});
export type AdminAudit = z.infer<typeof AdminAudit>;

export const RevealRequest = z.object({
  fields: z.array(MaskableFieldKeySchema).min(1),
  reason: z.string().min(1).max(500),
});
export type RevealRequest = z.infer<typeof RevealRequest>;
